import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

const itemDetails = {
  pluralName: "work_order_attachments",
  singularName: "work_order_attachment",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_attachment: {
      ...jsConn.formParams,
    },
  };
};

interface WorkOrderAttachmentState {
  workOrderAttachments: any[];
}

const state: WorkOrderAttachmentState = {
  workOrderAttachments: [],
};

const mutations = {
  LOAD_WORK_ORDER_ATTACHMENTS(state: WorkOrderAttachmentState, payload: any[]) {
    state.workOrderAttachments = payload;
  },
};

const actions = {
  createWorkOrderAttachment(_context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api
      .uploadFile(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
  deleteWorkOrderAttachment(_context: any, jsConn: JSConn) {
    // set the api params to be correct
    // this may be called from multiple places
    // as of 2019-04-24 it is just called from the
    // workorder show page and there the entire attachment
    // is being set as the form params
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .deleteItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  workOrderAttachments: (state: WorkOrderAttachmentState) =>
    state.workOrderAttachments,
};

const workOrderAttachmentsModule = {
  state,
  mutations,
  actions,
  getters,
};

export default workOrderAttachmentsModule;
